export const mutation_add_autovalutazioneAvv = `
mutation insertAutovalutazioneAvvocati($tenantId: String!,$aziendaId: Int!,$analisiNMesi: Int!,$areaGeografica: String!,$isAreaItalia: Boolean!,$areaRischioId: Int!,$areaClientiTipoId: Int!,$isMotivoIdent: Boolean!,$chkMotivoIdent1: Boolean!,$chkMotivoIdent2: Boolean!,$chkMotivoIdent3: Boolean!,$chkMotivoIdent4: Boolean!,$chkMotivoIdent5: Boolean!,$attivitaTipicaId: Int!,$isAttivitaContenziosa: Boolean!,$clientiTipoId: Int!, $clientiSettore: String!,$isClientiAreaSensibile: Boolean!,$isClientiProvenienzaVaria: Boolean!,$clientiProvenienzaId: Int!,$clientiProvenienzaNote: String!,$risultatiId: Int!,$rischioProvvedimentoId: Int!,$rischioProvvedimentoNote: String!,$chkProcedure1: Boolean!,$chkProcedure2: Boolean!,$chkProcedure3: Boolean!,$chkProcedure4: Boolean!,$chkProcedure5: Boolean!,$responsabileId: String!,$date: timestamp!,$createdBy: String!,$modifiedBy: String!,$provdedBy: String!,$expireDate:date!,$operateInRisk: Boolean!, $specificCase: String!,$whistleBlowingId:Int!,$whistleBlowingNotes:String!,$territoryRisk: Boolean!){
    insert_autovalutazione_avvocati_one(object: {TenantId: $tenantId, AziendaId: $aziendaId, AnalisiNMesi : $analisiNMesi,AreaGeografica:$areaGeografica,IsAreaItalia : $isAreaItalia, AreaRischioId:$areaRischioId, AreaClientiTipoId:$areaClientiTipoId, IsMotivoIdent :$isMotivoIdent, ChkMotivoIdent1:$chkMotivoIdent1, ChkMotivoIdent2:$chkMotivoIdent2, ChkMotivoIdent3:$chkMotivoIdent3, ChkMotivoIdent4:$chkMotivoIdent4, ChkMotivoIdent5:$chkMotivoIdent5, AttivitaTipicaId : $attivitaTipicaId, IsAttivitaContenziosa:$isAttivitaContenziosa, ClientiTipoId:$clientiTipoId, ClientiSettore: $clientiSettore, IsClientiAreaSensibile : $isClientiAreaSensibile, IsClientiProvenienzaVaria : $isClientiProvenienzaVaria, ClientiProvenienzaId : $clientiProvenienzaId, ClientiProvenienzaNote : $clientiProvenienzaNote, RisultatiId : $risultatiId, RischioProvvedimentoId : $rischioProvvedimentoId, RischioProvvedimentoNote : $rischioProvvedimentoNote, ChkProcedure1 : $chkProcedure1,ChkProcedure2 : $chkProcedure2,ChkProcedure3: $chkProcedure3,ChkProcedure4 : $chkProcedure4,ChkProcedure5: $chkProcedure5, ResponsabileId : $responsabileId, Date : $date, ProvdedBy : $provdedBy, CreatedBy : $createdBy, ModifiedBy:$modifiedBy, ExpireDate: $expireDate,OperateInRisk: $operateInRisk, SpecificCase: $specificCase, WhistleBlowingId: $whistleBlowingId, WhistleBlowingNotes : $whistleBlowingNotes, TerritoryRisk: $territoryRisk, CreatedOn : "now()"}) {
        Id
        TenantId
        AziendaId
        AnalisiNMesi
        AreaGeografica
        IsAreaItalia
        AreaRischioId
        AreaClientiTipoId
        IsMotivoIdent
        ChkMotivoIdent1
        ChkMotivoIdent2
        ChkMotivoIdent3
        ChkMotivoIdent4
        ChkMotivoIdent5
        AttivitaTipicaId
        IsAttivitaContenziosa
        ClientiTipoId
        ClientiSettore
        IsClientiAreaSensibile
        IsClientiProvenienzaVaria
        ClientiProvenienzaId
        ClientiProvenienzaNote
        RisultatiId
        RischioProvvedimentoId
        RischioProvvedimentoNote
        ChkProcedure1
        ChkProcedure2
        ChkProcedure3
        ChkProcedure4
        ChkProcedure5
        ResponsabileId
        Date
        CreatedBy
        ModifiedBy
        CreatedOn
        ModifiedOn
        ProvdedBy
        ExpireDate
        OperateInRisk
        SpecificCase 
        WhistleBlowingId
        WhistleBlowingNotes
        TerritoryRisk
    }
}`;
export const mutation_update_autovalutazioneAvv = `
mutation updateAutovalutazioneAvvocati($id: Int!, $tenantId: String!,$aziendaId: Int!,$analisiNMesi: Int!,$areaGeografica: String!,$isAreaItalia: Boolean!,$areaRischioId: Int!,$areaClientiTipoId: Int!,$isMotivoIdent: Boolean!,$chkMotivoIdent1: Boolean!,$chkMotivoIdent2: Boolean!,$chkMotivoIdent3: Boolean!,$chkMotivoIdent4: Boolean!,$chkMotivoIdent5: Boolean!,$attivitaTipicaId: Int!,$isAttivitaContenziosa: Boolean!,$clientiTipoId: Int!, $clientiSettore: String!,$isClientiAreaSensibile: Boolean!,$isClientiProvenienzaVaria: Boolean!,$clientiProvenienzaId: Int!,$clientiProvenienzaNote: String!,$risultatiId: Int!,$rischioProvvedimentoId: Int!,$rischioProvvedimentoNote: String!,$chkProcedure1: Boolean!,$chkProcedure2: Boolean!,$chkProcedure3: Boolean!,$chkProcedure4: Boolean!,$chkProcedure5: Boolean!,$responsabileId: String!,$date: timestamp!,$createdBy: String!,$modifiedBy: String!,$provdedBy: String!,$expireDate:date!, $operateInRisk: Boolean!, $specificCase: String!,$whistleBlowingId:Int!,$whistleBlowingNotes:String!,$territoryRisk: Boolean!) {
    update_autovalutazione_avvocati(where: {Id: {_eq: $id}, TenantId: {_eq: $tenantId}, AziendaId: {_eq:$aziendaId}}, _set: { AnalisiNMesi : $analisiNMesi,AreaGeografica:$areaGeografica,IsAreaItalia : $isAreaItalia, AreaRischioId:$areaRischioId, AreaClientiTipoId:$areaClientiTipoId, IsMotivoIdent :$isMotivoIdent, ChkMotivoIdent1:$chkMotivoIdent1, ChkMotivoIdent2:$chkMotivoIdent2, ChkMotivoIdent3:$chkMotivoIdent3, ChkMotivoIdent4:$chkMotivoIdent4, ChkMotivoIdent5:$chkMotivoIdent5, AttivitaTipicaId : $attivitaTipicaId, IsAttivitaContenziosa:$isAttivitaContenziosa, ClientiTipoId:$clientiTipoId, ClientiSettore: $clientiSettore, IsClientiAreaSensibile : $isClientiAreaSensibile, IsClientiProvenienzaVaria : $isClientiProvenienzaVaria, ClientiProvenienzaId : $clientiProvenienzaId, ClientiProvenienzaNote : $clientiProvenienzaNote, RisultatiId : $risultatiId, RischioProvvedimentoId : $rischioProvvedimentoId, RischioProvvedimentoNote : $rischioProvvedimentoNote, ChkProcedure1 : $chkProcedure1,ChkProcedure2 : $chkProcedure2,ChkProcedure3: $chkProcedure3,ChkProcedure4 : $chkProcedure4,ChkProcedure5: $chkProcedure5, ResponsabileId : $responsabileId, Date : $date, ProvdedBy : $provdedBy, CreatedBy:$createdBy, ModifiedBy: $modifiedBy,ExpireDate:$expireDate, OperateInRisk: $operateInRisk, SpecificCase: $specificCase, WhistleBlowingId: $whistleBlowingId, WhistleBlowingNotes : $whistleBlowingNotes,TerritoryRisk:$territoryRisk, ModifiedOn : "now()" }) {
        returning 
        {
        Id
        TenantId
        AziendaId
        AnalisiNMesi
        AreaGeografica
        IsAreaItalia
        AreaRischioId
        AreaClientiTipoId
        IsMotivoIdent
        ChkMotivoIdent1
        ChkMotivoIdent2
        ChkMotivoIdent3
        ChkMotivoIdent4
        ChkMotivoIdent5
        AttivitaTipicaId
        IsAttivitaContenziosa
        ClientiTipoId
        ClientiSettore
        IsClientiAreaSensibile
        IsClientiProvenienzaVaria
        ClientiProvenienzaId
        ClientiProvenienzaNote
        RisultatiId
        RischioProvvedimentoId
        RischioProvvedimentoNote
        ChkProcedure1
        ChkProcedure2
        ChkProcedure3
        ChkProcedure4
        ChkProcedure5
        ResponsabileId
        Date
        CreatedBy
        ModifiedBy
        CreatedOn
        ModifiedOn
        ProvdedBy
        ExpireDate
        OperateInRisk
        SpecificCase 
        WhistleBlowingId
        WhistleBlowingNotes
        TerritoryRisk
        }
    }
}`;
export const mutation_delete_autovalutazioneAvv = `
mutation deleteAutovalutazioneAvvocati($id:Int!){
    delete_autovalutazione_avvocati(where: {Id: {_eq:$id}}){
        affected_rows
    }
}`;